
import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  TableRow,
  Paper,
  Checkbox,
  Tooltip,
  Box,
  DialogContentText,
  TableFooter,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { EyeOutlined } from "@ant-design/icons";
// import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useSelector } from "react-redux";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { border, height, width } from "@mui/system";
import HttpService from "../services/httpService";
import { CSVLink } from "react-csv";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { ROLENAME } from '../utils';

import axios from "axios";
import { Header } from "antd/es/layout/layout";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    zIndex: 2,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    position: "relative",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxWidth: 400,
    margin: "0 auto",
  },
  button: {
    marginTop: theme.spacing(2),
  },
  table: {
    minWidth: 650,
    border: "1px solid #ddd", // Add border to the table
  },
  tableCell: {
    textAlign: "center",
    border: "1px solid #ddd", // Add border to table cells
    whiteSpace: "normal", // Allow wrapping of content
    wordWrap: "break-word", // Break words that exceed the width
    maxWidth: "150px", // Example maximum width
    padding: "8px", // Adjust padding as needed
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  input: {
    display: "none",
  },
  downloadButton: {
    backgroundColor: '#355025',   // Dark Blue
    color: '#FFF2EB',             // White text
    '&:hover': {
      backgroundColor: '#4A6641', // Derived lighter Dark Blue
    },
  },
}));
function IncentiveForDesignTeam(props) {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [incentivesData, setIncentivesData] = useState({});
  const [adminIncentives, setAdminIncentivesData] = useState({});
  const [yearFilterValue, setYearFilterValue] = useState(
    new Date().getFullYear()
  );
  const [radioValue, setRadioValue] = useState("NA");
  const [monthFilter, setMonthFilter] = useState("all");
  // const [hierarchyHeader, setHierarchyHeader] = useState([]);
  const [hierarchyCsv, setHierarchyCsv] = useState([]);
  const [initiatePipInfo, setInitiatePipInfo] = useState({});
  const [allExeperienceCenter, setAllExperienceCenter] = useState({});
  const [selectExperienceCenter, setSelectExperienceCenter] = useState("all");
  const [hierarchyCsvData, setHierarchyCsvData] = useState([]);
  const [adminCsvData, setAdminCsvData] = useState([]);
  const [hierarchyHeader, setHierarchyHeader] = useState([])
  const [adminToggle, setAdminToggle] = useState(false)


  // rupees format----
  function formatRupees(amount) {
    const amountInLacs = amount / 100000;
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    }).format(amountInLacs);
  }

  function flattenedDataFunHandle(data) {
    return data?.map((item) => {
      let formattedItem = {
        name: item.name || "N/A",
        role: item?.roles?.join(", ") || "N/A",
        ec: item?.experienceCenters?.join(", ") || "N/A",
      };

      // Dynamically assign month-based keys
      item?.data?.forEach((entry) => {
        if (entry?.month) {
          formattedItem[entry.month] = entry.incentive || 0;
        }
      });

      return formattedItem;
    }) || [];
  }

  // finding month name via numbers
  function findMonthName(monthNumber) {
    const result =
      monthNumber === 1
        ? "Jan"
        : monthNumber === 2
          ? "Feb"
          : monthNumber === 3
            ? "March"
            : monthNumber === 4
              ? "Apr"
              : monthNumber === 5
                ? "May"
                : monthNumber === 6
                  ? "June"
                  : monthNumber === 7
                    ? "July"
                    : monthNumber === 8
                      ? "Aug"
                      : monthNumber === 9
                        ? "Sept"
                        : monthNumber === 10
                          ? "Oct"
                          : monthNumber === 11
                            ? "Nov"
                            : monthNumber === 12
                              ? "Dec"
                              : "Invalid month";

    return result;
  }

  // Get All Experience Center

  async function getExperienceCenterHandleFun() {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getAllExperienceCenter();
      setAllExperienceCenter(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }
  //   get Incentives api call
  async function getIncentivesHandle(year, month, userId) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService?.getIncentivesHierarchyWiseForDesign(
        year,
        month,
        userId
      );
      setIncentivesData(fetchData?.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }


  //   get Incentives Admin api call
  async function getAdminIncentivesHandle(year, month, ecId) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getAdminIncentivesApiForDesign(
        year,
        month,
        ecId
      );
      setAdminIncentivesData(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }


  useEffect(() => {
    if (userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) {
      getAdminIncentivesHandle(
        yearFilterValue,
        monthFilter,
        selectExperienceCenter
      );
      getExperienceCenterHandleFun();
    } else {
      getIncentivesHandle(yearFilterValue, monthFilter, userDetails?._id);
    }
  }, [yearFilterValue, monthFilter, selectExperienceCenter, userDetails]);

  //CSV useEffect---------


  useEffect(() => {
    const emptyRow = {
      name: "",
      role: "",
      ec: "",
      1: "", // Ensure value exists, otherwise default to 0
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
      7: "",
      8: "",
      9: "",
      10: "",
      11: "",
      12: ""
    };

    // admin falttend data
    if (userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) {
      const forAdminVisibilityDgmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.dgmData
      );
      const forAdminVisibilityAgmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.agmData
      );
      const forAdminVisibilitySmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.dmData
      );
      const forAdminVisibilityAsmFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.admData
      );
      const forAdminVisibilitySeFlattenData = flattenedDataFunHandle(
        adminIncentives?.data?.executiveData
      );

      if (radioValue === "all") {
        setAdminCsvData([
          ...forAdminVisibilityDgmFlattenData,
          emptyRow,
          ...forAdminVisibilityAgmFlattenData,
          emptyRow,
          ...forAdminVisibilitySmFlattenData,
          emptyRow,
          ...forAdminVisibilityAsmFlattenData,
          emptyRow,
          ...forAdminVisibilitySeFlattenData,
        ]);
      } else if (radioValue === "DGM") {
        setAdminCsvData(forAdminVisibilityDgmFlattenData);
      } else if (radioValue === "AGM") {
        setAdminCsvData(forAdminVisibilityAgmFlattenData);
      } else if (radioValue === "ODM") {
        setAdminCsvData(forAdminVisibilitySmFlattenData);
      } else if (radioValue === "ADM") {
        setAdminCsvData(forAdminVisibilityAsmFlattenData);
      } else if (radioValue === "DE") {
        setAdminCsvData(forAdminVisibilitySeFlattenData);
      }
    }
    // Hierarchy falttend data
    else {
      const hierarchyDgmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.dgmData
      );
      const hierarchyAgmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.agmData
      );
      const hierarchySmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.dmData
      );
      const hierarchyAsmFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.admData
      );
      const hierarchySeFlattenData = flattenedDataFunHandle(
        incentivesData?.data?.executiveData
      );

      if (radioValue === "NA") {
        setHierarchyCsvData([
          ...hierarchyDgmFlattenData,
          emptyRow,
          ...hierarchyAgmFlattenData,
          emptyRow,
          ...hierarchySmFlattenData,
          emptyRow,
          ...hierarchyAsmFlattenData,
          emptyRow,
          ...hierarchySeFlattenData,
        ]);
      } else if (radioValue === "DGM") {
        setHierarchyCsvData(hierarchyDgmFlattenData);
      } else if (radioValue === "AGM") {
        setHierarchyCsvData(hierarchyAgmFlattenData);
      } else if (radioValue === "ODM") {
        setHierarchyCsvData(hierarchySmFlattenData);
      } else if (radioValue === "ADM") {
        setHierarchyCsvData(hierarchyAsmFlattenData);
      } else if (radioValue === "DE") {
        setHierarchyCsvData(hierarchySeFlattenData);
      }
    }
  }, [incentivesData, radioValue, adminIncentives]);


  useEffect(() => {
    if (!incentivesData?.data?.executiveData?.[0]?.data) {
      console.error("Executive data is undefined or empty.");
      return;
    }
    // Extract unique `year` values
    const tempArr = incentivesData.data.executiveData[0].data.map((ele) =>
      ele
        ? { year: ele?.year, month: ele?.month }
        : "Unknown Year"
    );
    // Construct headers
    const headers = [
      { key: "name", label: "Name" },
      { key: "role", label: "Designation" },
      { key: "ec", label: "Experience-Center" },
      ...tempArr.map((ele) => ({
        key: ele?.month?.toString(),
        label: `${findMonthName(ele?.month)}-${ele?.year}`,
      })),
    ];
    setHierarchyHeader(headers);
  }, [incentivesData]);

  useEffect(() => {
    if (!adminIncentives?.data?.executiveData?.[0]?.data) {
      console.error("Executive data is undefined or empty.");
      return;
    }
    // Extract unique `year` values
    const tempArr = adminIncentives?.data?.executiveData[0]?.data.map((ele) =>
      ele
        ? { year: ele?.year, month: ele?.month }
        : "Unknown Year"
    );
    // Construct headers
    const headers = [
      { key: "name", label: "Name" },
      { key: "role", label: "Designation" },
      { key: "ec", label: "Experience-Center" },
      ...tempArr.map((ele) => ({
        key: ele?.month?.toString(),
        label: `${findMonthName(ele?.month)}-${ele?.year}`,
      })),
    ];
    setHierarchyHeader(headers);
  }, [adminIncentives]);

  // Select Radio Button Logic
  useEffect(() => {
    if (userDetails?.roles?.some((role) => role?.name === ROLENAME.DGM_Design)) {
      setRadioValue("DGM")
    }
    if (userDetails?.roles?.some((role) => role?.name === ROLENAME.AGM_Design)) {
      setRadioValue("AGM")
    }
    if (userDetails?.roles?.some((role) => role?.name === ROLENAME.OperationDesignManager)) {
      setRadioValue("ODM")
    }
    if (userDetails?.roles?.some((role) => role?.name === ROLENAME.AssistantDesignManager)) {
      setRadioValue("ADM")
    }
    if (userDetails?.roles?.some((role) => role?.name === ROLENAME.DesignUser)) {
      setRadioValue("DE")
    }
  }, [userDetails])

  const currentYear = new Date().getFullYear();
  const financialYears = [
      { value: currentYear - 2, label: `${currentYear - 2}` },
      { value: currentYear - 1, label: `${currentYear - 1}` },
      { value: currentYear, label: `${currentYear}` },
  ];

  return (
    <div>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        {/* ----Year filter---- */}
        <Box sx={{ display: "flex" }}>
          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="demo-select-small-label">Year</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={yearFilterValue}
              label="Select Experience"
              onChange={(e) => {
                setYearFilterValue(e.target.value);
              }}
            >
              {financialYears.map((year) => (
                <MenuItem key={year.value} value={year.value}>
                  {year.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* -------------------Select Months----------------- */}

          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="demo-select-small-label">Month</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={monthFilter}
              label="Select Experience"
              onChange={(e) => {
                setMonthFilter(e.target.value);
              }}
            >
              <MenuItem value={"all"}>{"All"}</MenuItem>
              <MenuItem value={1}>{"Jan"}</MenuItem>
              <MenuItem value={2}>{"Feb"}</MenuItem>
              <MenuItem value={3}>{"March"}</MenuItem>
              <MenuItem value={4}>{"April"}</MenuItem>
              <MenuItem value={5}>{"May"}</MenuItem>
              <MenuItem value={6}>{"June"}</MenuItem>
              <MenuItem value={7}>{"July"}</MenuItem>
              <MenuItem value={8}>{"Aug"}</MenuItem>
              <MenuItem value={9}>{"Sept"}</MenuItem>
              <MenuItem value={10}>{"Oct"}</MenuItem>
              <MenuItem value={11}>{"Nov"}</MenuItem>
              <MenuItem value={12}>{"Dec"}</MenuItem>
            </Select>
          </FormControl>

          {/* ------------experience Center option------- */}
          {userDetails?.roles?.some(
            (role) =>
              role?.name?.includes("Admin") ||
              role?.name?.includes("Center Head") ||
              role?.name?.includes("Finance Executive") ||
              role?.name?.includes("Finance User") ||
              role?.name?.includes("Finance Manager")
          ) && (
            <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
              <InputLabel id="experience-center-label">
                Experience Center
              </InputLabel>
              <Select
                labelId="experience-center-label"
                id="experience-center-select"
                value={selectExperienceCenter}
                label="Experience Center"
                onChange={(e) => setSelectExperienceCenter(e.target.value)}
              >
                {/* Default Option */}
                <MenuItem value="all">All</MenuItem>

                {/* Render Options Dynamically */}
                {userDetails?.roles?.some(
                  (role) =>
                    role?.name?.includes("Admin") ||
                    role?.name?.includes("Center Head") ||
                    role?.name?.includes("Finance Executive") ||
                    role?.name?.includes("Finance User") ||
                    role?.name?.includes("Finance Manager")
                ) &&
                  allExeperienceCenter?.data?.length > 0 &&
                  allExeperienceCenter.data.map((ele) => (
                    <MenuItem key={ele?._id} value={ele?._id}>
                      {ele.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
          {/* ----------------Radio buttons------------------ */}
          {!userDetails?.roles?.some((role) =>
            role?.name?.includes("Design User") || role?.name?.includes("Admin") || role?.name === ROLENAME.CenterHead || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
          ) && (
              <Box>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    Select Role
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={radioValue}
                    name="radio-buttons-group"
                    sx={{ display: "flex", flexDirection: "row" }} // Add flexDirection: "row"
                    onChange={(e) => {
                      setRadioValue(e.target.value);
                    }}
                  >
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")      
                    ) && (
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All"
                      />
                      )} 
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="DGM"
                          control={<Radio />}
                          label="DGM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="AGM"
                          control={<Radio />}
                          label="AGM"
                        />
                      )}
                      {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ODM"
                          control={<Radio />}
                          label="ODM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Assistant Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel value="ADM" control={<Radio />} label="ADM" />
                      )}
                    <FormControlLabel value="DE" control={<Radio />} label="DE" />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

          {/*  new.... */}
          {
            userDetails?.roles?.find(role => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
            ) && (
              <Box>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    Select Role
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={radioValue}
                    name="radio-buttons-group"
                    sx={{ display: "flex", flexDirection: "row" }} // Add flexDirection: "row"
                    onChange={(e) => {
                      setRadioValue(e.target.value);
                      setAdminToggle(true)
                    }}
                  >


                    <FormControlLabel
                      value="all"
                      control={<Radio />}
                      label="All"
                    />


                    <FormControlLabel
                      value="DGM"
                      control={<Radio />}
                      label="DGM"
                    />

                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("DesignHead") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="AGM"
                          control={<Radio />}
                          label="AGM"
                        />
                      )}
                       {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("DesignHead") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ODM"
                          control={<Radio />}
                          label="ODM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("DesignHead") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Assistant Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ADM"
                          control={<Radio />}
                          label="ADM"
                        />
                      )}
                   
                    <FormControlLabel value="DE" control={<Radio />} label="DE" />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}
        </Box>
        {/* ----Download Csv---- */}
        {!userDetails?.roles?.some(
          (role) =>
            role?.name?.includes("Admin") ||
            role?.name?.includes("Center Head") ||
            role?.name?.includes("Finance Executive") ||
            role?.name?.includes("Finance User") ||
            role?.name?.includes("Finance Manager")
        ) &&
          hierarchyCsvData?.length > 0 &&
          monthFilter === "all" &&
          hierarchyHeader.length > 0 && (
            <Button
              variant="contained"
              color="primary"
              style={{
                height: "40px",
                marginTop: "6px",
                marginLeft: "8px",
                fontSize: "12px",
              }}
              className={classes.downloadButton}
            >
              <CSVLink
                data={hierarchyCsvData || []}
                headers={hierarchyHeader || []}
                filename={`incentives of ${yearFilterValue}`}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  // fontSize: "15px",
                }}
              >
                Download CSV Data
              </CSVLink>
            </Button>
          )}

        {userDetails?.roles?.some(
          (role) =>
            role?.name?.includes("Admin") ||
            role?.name?.includes("Center Head") ||
            role?.name?.includes("Finance Executive") ||
            role?.name?.includes("Finance User") ||
            role?.name?.includes("Finance Manager")
        ) &&
          adminCsvData?.length > 0 &&
          monthFilter === "all" &&
          hierarchyHeader.length > 0 && (
            <Button
              variant="contained"
              color="primary"
              style={{
                height: "40px",
                marginTop: "6px",
                marginLeft: "8px",
                fontSize: "12px",
              }}
              className={classes.downloadButton}
            >
              <CSVLink
                data={adminCsvData || []}
                headers={hierarchyHeader || []}
                filename={`incentives of ${yearFilterValue}`}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  // fontSize: "15px",
                }}
              >
                Download CSV Data
              </CSVLink>
            </Button>
          )}
      </Box>
      <Box style={{ textAlign: "right" }}>
        {" "}
        <b> All the amounts are showing in lacs ( ₹ )</b>
        {monthFilter !== "all" &&
          !userDetails?.roles?.some(
            (role) =>
              role?.name?.includes("Admin") ||
              role?.name?.includes("Center Head") ||
              role?.name?.includes("Finance Executive") ||
              role?.name?.includes("Finance User") ||
              role?.name?.includes("Finance Manager")
          ) &&
          Array.isArray(incentivesData?.data?.executiveData) &&
          incentivesData?.data?.executiveData[0]?.data?.length > 0 && (
            <h4 style={{ marginTop: "10px", color: "green" }}>
              Showing data in table from 11th{" "}
              {findMonthName(
                incentivesData?.data?.executiveData[0]?.data[0]?.month
              )}{" "}
              {incentivesData?.data?.executiveData[0]?.data[0]?.year} To 11th{" "}
              {findMonthName(
                incentivesData?.data?.executiveData[1]?.data[1]?.month
              )}{" "}
              {incentivesData?.data?.executiveData[1]?.data[1]?.year}
            </h4>
          )}
        {monthFilter !== "all" &&
          userDetails?.roles?.some(
            (role) =>
              role?.name?.includes("Admin") ||
              role?.name?.includes("Center Head") ||
              role?.name?.includes("Finance Executive") ||
              role?.name?.includes("Finance User") ||
              role?.name?.includes("Finance Manager")
          ) &&
          Array.isArray(adminIncentives?.data?.executiveData) &&
          adminIncentives?.data?.executiveData[0]?.data?.length > 0 && (
            <h4 style={{ marginTop: "10px", color: "green" }}>
              Showing data in table from 11th{" "}
              {findMonthName(
                adminIncentives?.data?.executiveData[0]?.data[0]?.month
              )}{" "}
              {adminIncentives?.data?.executiveData[0]?.data[0]?.year} To 11th{" "}
              {findMonthName(
                adminIncentives?.data?.executiveData[1]?.data[1]?.month
              )}{" "}
              {adminIncentives?.data?.executiveData[1]?.data[1]?.year}
            </h4>
          )}
      </Box>
      {userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        radioValue !== "NA" && // Ensures the message doesn't show when radioValue is "NA"
        !adminIncentives?.data?.dgmData?.length &&
        !adminIncentives?.data?.agmData?.length &&
        !adminIncentives?.data?.dmData?.length &&
        !adminIncentives?.data?.admData?.length &&
        !adminIncentives?.data?.executiveData?.length && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilterValue}
          </div>
        )}
      {!userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        !incentivesData?.data?.dgmData?.length > 0 &&
        !incentivesData?.data?.agmData?.length > 0 &&
        !incentivesData?.data?.dmData?.length > 0 &&
        !incentivesData?.data?.admData?.length > 0 &&
        !incentivesData?.data?.executiveData?.length > 0 && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilterValue}
          </div>
        )}

      {/* -------------------Admin Table DGM---------------- */}
      {userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(adminIncentives) !== "{}" &&
        (radioValue === "all" || radioValue === "DGM") &&
        adminIncentives?.data?.dgmData[0]?.data?.length > 0 && (
          <div>
            <h3> DGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.dgmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            key={`${ele.month}-${ele.year}`}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.dgmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc =
                                    ec.length > 19
                                      ? `${ec.slice(0, 19)}..`
                                      : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table AGM---------------- */}
      {userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(adminIncentives) !== "{}" &&
        (radioValue === "all" || radioValue === "AGM") &&
        adminIncentives?.data?.agmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> AGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.agmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.agmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc =
                                    ec.length > 19
                                      ? `${ec.slice(0, 19)}..`
                                      : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table ODM---------------- */}
      {userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(adminIncentives) !== "{}" &&
        (radioValue === "all" || radioValue === "ODM") &&
        adminIncentives?.data?.dmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> ODM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.dmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.dmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc =
                                    ec.length > 19
                                      ? `${ec.slice(0, 19)}..`
                                      : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table ADM---------------- */}
      {userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        (radioValue === "all" || radioValue === "ADM") &&
        JSON.stringify(adminIncentives) !== "{}" &&
        adminIncentives?.data?.admData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> ADM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.admData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.admData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc =
                                    ec.length > 19
                                      ? `${ec.slice(0, 19)}..`
                                      : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Admin Table DE---------------- */}
      {userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        (radioValue === "all" || radioValue === "DE") &&
        JSON.stringify(adminIncentives) !== "{}" &&
        adminIncentives?.data?.executiveData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> DE Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(adminIncentives) !== "{}" &&
                      adminIncentives?.data?.executiveData[0]?.data?.map(
                        (ele) => {
                          return (
                            <TableCell
                              className={classes.tableCell}
                              style={{
                                fontWeight: 800,
                                backgroundColor: "#cccccc",
                              }}
                            >
                              {findMonthName(ele.month)}-{ele.year}
                            </TableCell>
                          );
                        }
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminIncentives?.data?.executiveData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc =
                                    ec.length > 19
                                      ? `${ec.slice(0, 19)}..`
                                      : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item?.data?.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table DGM---------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "DGM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.dgmData[0]?.data?.length > 0 && (
          <div>
            <h3> DGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.dgmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.dgmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc =
                                    ec.length > 19
                                      ? `${ec.slice(0, 19)}..`
                                      : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table AGM---------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "AGM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.agmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> AGM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.agmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.agmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={item?.experienceCenters?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {item?.experienceCenters
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc =
                                    ec.length > 19
                                      ? `${ec.slice(0, 19)}..`
                                      : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {item?.experienceCenters?.length > 2 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table ODM---------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "ODM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.dmData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> ODM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.dmData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.dmData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item?.experienceCenters?.map((ec, index, array) => {
                            return (
                              <span key={index}>
                                {ec}
                                {index < array.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table ADM---------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "ADM") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.admData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> ADM Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.admData[0]?.data?.map((ele) => {
                        return (
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              fontWeight: 800,
                              backgroundColor: "#cccccc",
                            }}
                          >
                            {findMonthName(ele.month)}-{ele.year}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.admData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item?.experienceCenters?.map((ec, index, array) => {
                            return (
                              <span key={index}>
                                {ec}
                                {index < array.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      {/* -------------------Hierarchy Table DE---------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") ||
          role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") ||
          role?.name?.includes("Finance User") ||
          role?.name?.includes("Finance Manager")
      ) &&
        JSON.stringify(incentivesData) !== "{}" &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "DE") &&
        Array.isArray(incentivesData?.data?.dgmData) && // Check if dgmData is an array
        incentivesData?.data?.executiveData[0]?.data?.length > 0 && (
          <div>
            <h3 style={{ marginTop: "12px" }}> DE Table </h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{
                        fontWeight: 800,
                        backgroundColor: "#cccccc",
                        width: "60px",
                      }}
                    >
                      Exp Center
                    </TableCell>
                    {JSON.stringify(incentivesData) !== "{}" &&
                      incentivesData?.data?.executiveData[0]?.data?.map(
                        (ele) => {
                          return (
                            <TableCell
                              className={classes.tableCell}
                              style={{
                                fontWeight: 800,
                                backgroundColor: "#cccccc",
                              }}
                            >
                              {findMonthName(ele.month)}-{ele.year}
                            </TableCell>
                          );
                        }
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {incentivesData?.data?.executiveData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {item?.experienceCenters?.map((ec, index, array) => {
                            return (
                              <span key={index}>
                                {ec}
                                {index < array.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </TableCell>
                        {item.data.map((ele) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {formatRupees(ele?.incentive)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
    </div>
  );
}

export default connect(null, { setLoading, setSnackInfo })(IncentiveForDesignTeam);
